export default ({ dropdown }) => ({
  disabled: {},
  dark: {},
  placeholder: {
    '&$dark': {
      color: dropdown.dark.placeholderColor
    },
    '&$disabled': {
      cursor: 'not-allowed'
    },
    display: 'inherit',
    color: dropdown.placeholderColor,
    background: 'transparent',
    border: 'none',
    padding: 0,
    fontSize: 16,
    fontFamily: dropdown.fontFamily,
    textAlign: 'left',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});
